import PlayerSegmentActionType from 'actions/playerSegment/playerSegmentActionType';

const initialState = {
  playersSegments: {},
  segmentsPlayers: {},
  playerSegment: {},
  playerIncludedSegments: {},
  playerExcludedSegments: [],
};

const playerSegmentReducer = (state = initialState, { type, payload }) => {
  switch (type) {
  case PlayerSegmentActionType.RESET_SEGMENTS_PLAYERS:
    return {
      ...state,
      segmentsPlayers: {},
    };
  case PlayerSegmentActionType.SAVE_PLAYERS_SEGMENTS:
    return {
      ...state,
      playersSegments: payload.data,
    };
  case PlayerSegmentActionType.SAVE_SEGMENTS_PLAYERS:
    return {
      ...state,
      segmentsPlayers: payload.data,
    };
  case PlayerSegmentActionType.RESET_PLAYERS_SEGMENTS:
    return {
      ...state,
      playersSegments: {},
    };
  case PlayerSegmentActionType.SAVE_PLAYER_INCLUDED_SEGMENTS:
    return {
      ...state,
      playerIncludedSegments: payload.data,
    };
  case PlayerSegmentActionType.RESET_PLAYER_INCLUDED_SEGMENTS:
    return {
      ...state,
      playerIncludedSegments: {},
    };
  case PlayerSegmentActionType.SAVE_PLAYER_EXCLUDED_SEGMENTS:
    return {
      ...state,
      playerExcludedSegments: payload.data,
    };
  case PlayerSegmentActionType.RESET_PLAYER_EXCLUDED_SEGMENTS:
    return {
      ...state,
      playerExcludedSegments: [],
    };
  case PlayerSegmentActionType.SAVE_PLAYER_SEGMENT: {
    return {
      ...state,
      playerSegment: payload.data,
    };
  }
  case PlayerSegmentActionType.RESET_PLAYER_SEGMENT: {
    return {
      ...state,
      playerSegment: {},
    };
  }
  default:
    return state;
  }
};

export default playerSegmentReducer;
